import { render, staticRenderFns } from "./Quadro.vue?vue&type=template&id=343353bc&"
import script from "./Quadro.vue?vue&type=script&lang=js&"
export * from "./Quadro.vue?vue&type=script&lang=js&"
import style0 from "./Quadro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports